import { Grid, Typography } from '@mui/material'
import React from 'react'
import Header from '../../common/Header'
import Footer from '../../common/Footer'

const PeopleHomePage = () => {
  return (
    <>
    <Header/>
    <Grid>
  {/* <BlogShowcase/> */}
    </Grid>
    <Footer variant="light" />
    
    </>
  )
}

export default PeopleHomePage